// extracted by mini-css-extract-plugin
export var cardIcon = "_43-4";
export var checkboxCard = "_43-0";
export var checkboxCardSelected = "_43-1";
export var disabled = "_43-2";
export var outerBorder = "_43-3";
export var spacerMedium = "_43-7";
export var spacerSmall = "_43-6";
export var spacerXsmall = "_43-5";